import BasePopupFormBuilder from "./BasePopupFormBuilder";

export class FormBuilder_k4q9s5t01cuoje extends BasePopupFormBuilder {
    constructor(
        {
            submitText = 'Get Started'
        } = {}
    ) {
        super({
            formAction: '/wp-admin/admin-post.php',
            formName: 'k4q9s5t01cuoje',
            title: 'Subscribe to Your SaaS Analytics Trial Now!',
            description: '',
            submitText,
        });
    }

    build(
        {
            container,
        }
    ) {
        super.build({
            container,
        });
        container.querySelector('.just-fill')?.remove()

        const form = container.querySelector('form');

        if (!form) {
            return;
        }

        /** @type {HTMLInputElement} */
        let formNameInput = form.querySelector('input[name="name-form"]');
        if (!formNameInput) {
            formNameInput = document.createElement('input');
            formNameInput.type = 'hidden';
            formNameInput.name = 'name-form';
            form.appendChild(formNameInput)
        }

        formNameInput.value = 'k4q9s5t01cuoje'

        /** @type {HTMLInputElement} */
        let formRedirectInput = form.querySelector('input[name="form-redirect"]');
        if (!formRedirectInput) {
            formRedirectInput = document.createElement('input');
            formRedirectInput.type = 'hidden';
            formRedirectInput.name = 'form-redirect';
            form.appendChild(formRedirectInput)
        }

        formRedirectInput.value = '/downloads/sharepoint-office365-analytics/saas-analytics-trial/thank-you/'

        /** @type {HTMLElement|null} */
        const countryInput = form.querySelector('.country-input');
        if (countryInput) {
            countryInput.name = 'Field19'
        }
    }
}
